'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { BaseModal } from '@components/base-modal';
import { Icon, IconNames } from '@components/icon';
import { Link } from '@components/link';
import { Typography } from '@components/typography';
import { routes } from '@routes';
import { SAVVY_PROMISE_BADGE_LABEL, SAVVY_PROMISE_MODAL_BODY, SAVVY_PROMISE_SUBTITLE, SAVVY_PROMISE_TITLE } from './savvy-promise-copy';
export interface SavvyPromiseModalProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * Lightweight Savvy Promise modal: a small mint-green shield tile, the
 * "The Savvy Promise" title with a "Book with Confidence" subtitle, a
 * single body paragraph, and a `Learn more →` text link that pushes to
 * the /savvy-promise landing page. Matches the comp from BHT-6145.
 */
export const SavvyPromiseModal: React.FC<SavvyPromiseModalProps> = t0 => {
  const $ = _c(10);
  const {
    isOpen,
    onClose
  } = t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="flex items-center gap-4"><span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-pool/50 text-primary-main" aria-hidden="true"><Icon name={IconNames.SHIELD_USER} size="xl" /></span><div><Typography component="h2" variant="title3" className="text-primary-main">{SAVVY_PROMISE_TITLE}</Typography><Typography component="p" variant="body2" className="mt-1 text-primary-main/70">{SAVVY_PROMISE_SUBTITLE}</Typography></div></div>;
    t2 = <Typography component="p" variant="body1" className="mt-5 text-primary-main/80">{SAVVY_PROMISE_MODAL_BODY}</Typography>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Typography component="span" variant="body2" className="font-semibold underline">Learn more</Typography>;
    t4 = <Icon name={IconNames.ARROW_RIGHT} size="xs" className="text-primary-main" />;
    $[2] = t3;
    $[3] = t4;
  } else {
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] !== onClose) {
    t5 = <div className="px-6 pb-6 pt-6 sm:px-8 sm:pb-7 sm:pt-7">{t1}{t2}<div className="mt-4"><Link to={routes.savvyPromise} dataId="savvy_promise_modal_learn_more" onClick={onClose} className="inline-flex items-center gap-1.5 text-primary-main hover:text-primary-light [text-decoration:none] hover:[text-decoration:none]">{t3}{t4}</Link></div></div>;
    $[4] = onClose;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isOpen || $[7] !== onClose || $[8] !== t5) {
    t6 = <BaseModal isOpen={isOpen} onClose={onClose} size="md" className="sm:max-w-2xl" ariaLabel={SAVVY_PROMISE_BADGE_LABEL}>{t5}</BaseModal>;
    $[6] = isOpen;
    $[7] = onClose;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
};
SavvyPromiseModal.displayName = 'SavvyPromiseModal';